"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @private
 */
exports.TARIFFS_ENDPOINT = {
    getIndex: '/pricing/{{version}}/tariffs/users/{{userUuid}}',
    postTariffToUser: '/pricing/{{version}}/tariffs/{{tariffWithQuotaUuid}}/users/{{userUuid}}',
    getIndexCompanyTariff: '/pricing/{{version}}/tariffs/companies/{{newCompanyUuid}}',
    postTariffToCompany: '/pricing/{{version}}/tariffs/{{businessTariffWithQuotaUuid}}/companies/{{newCompanyUuid}}',
    getLongDistanceCalculator: '/pricing/{{version}}/ld-calculator?start={{start}}&end={{end}}&insurance={{insurance}}&estimated_kms={{estimatedKms}}',
};
